
class SingleEvenement {
  private container: HTMLElement | null;
  constructor() {
    this.container = document.querySelector('.single-evenement')

    if (!this.container)
      return
    this._init();
  }

  _init() {
    this.scrollToInscription();
    this.confirmation();
  }

  scrollToInscription() {
    if (!this.container)
      return
    const scrollButton = this.container?.querySelector<HTMLButtonElement>('[data-single-evenement-scroll]');
    const targetElement = document.getElementById('inscription');
    const headerElement = document.querySelector<HTMLElement>('header');

    if (scrollButton && targetElement && headerElement) {
      scrollButton.addEventListener('click', () => {
        const headerHeight = headerElement.offsetHeight;
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const scrollTargetY = targetPosition - headerHeight;

        window.scrollTo({
          top: scrollTargetY,
          behavior: 'smooth'
        });
      });

    }
  }
  confirmation() {
    document.addEventListener('wpcf7mailsent', (event) => {

      const form = this.container?.querySelector<HTMLElement>('[data-single-evenement-form]');
      const success = this.container?.querySelector<HTMLElement>('[data-single-evenement-success]');

      if (form && success) {
        form.classList.add('hidden');
        success.classList.remove('hidden')
      }

    }, false);
  }
}

export const singleEvenement = new SingleEvenement();
